<template>
    <div class="container-fluid">
      <!-- ชุดตรวจ -->
      <div class="row ">
          <div class="col-sm-7">
              <div class="row">
                <div class="col">
                  <!-- แสดงปุ่มคลิก Checkbox แถว -->
                  <div class="btn-group float-sm-start" role="group" v-if="TSselectedlist.length>0">
                    <button id="MoveRoom" type="button"
                      class="btn btn-info dropdown-toggle my-2" data-bs-toggle="dropdown" aria-expanded="false">
                      <i class="fa fa fa-retweet me-2"></i>ย้ายไปที่ห้องตรวจ.. <span class="badge rounded-pill bg-white text-success ms-2">{{TSselectedlist.length}}</span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <li v-for="item in roomtypeRows" :key="item.id"><a class="dropdown-item" @click="changeRoomtypeForTSSelected(item)">{{item.room_name}}</a></li>
                    </ul>
                  </div>
                  <button type="button" class="btn btn-primary float-sm-end my-2" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="newRecord()" style="width:200px;">New</button>
                </div>
              </div>
              <div class="container-fluid p-2 border border-2 border-secondary shadow" style="height: 800px;">
                <div class="mh-100 vh-100 overflow-auto ">
                  <table id="myTSTable" class="table table-hover display table-sm" style="width: 100%;">
                      <thead class="text-white" style="background:Navy">
                      <tr>
                          <th class="text-start" style="width:10px;" hidden>Seq.</th>
                          <th class="text-start" style="width:10px;" hidden>Seq.</th>
                          <th style="width:10px;"></th>
                          <th class="text-start" style="width:30px;">รหัสชุด</th>
                          <th class="text-center" style="width:15px;" title="เป็นชุดตรวจที่สร้างมาจากเทส">Clone</th>
                          <th class="text-start" style="width:300px;">ชื่อชุดเทส</th>
                          <th class="text-end" style="width:120px;">ราคาขาย 1-5</th>
                          <th style="width:100px;">ห้องตรวจ</th>
                          <th style="width:10px;">Count</th>
                          <th style="width:80px;">คำสั่ง</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in datalists" :key="item.TestID" class="py-0"
                          :data-TestID="item.TestID" :data-PriorityIdx="item.PriorityIdx"
                          @click="tableChanged($event, item)">
                            <td class="text-start py-1" hidden>{{ item.room_seq }}</td>
                            <td class="text-start py-1" hidden>{{item.Seq}}</td>
                            <td class="py-1">
                              <input class="mt-1" type="checkbox" title="คลิกเพื่อเลือกรายการ" v-model="TSselectedlist"
                                style="width:20px;height:20px;"
                                :name="'chkTest' + item.TestID" :id="'chkTest' + item.TestID" :value="item" autocomplete="off">
                            </td>
                            <td class="text-start py-1">{{ item.TestCode }}</td>
                            <td class="text-center py-1"> <span v-if="item.FromItemTest==1" title="สร้างมาจากเทสตรวจ (เมนู Master -> เทสตรวจ)"><i class="fa fa-clone text-warning"></i></span></td>
                            <td class="text-start py-1"><b>{{ item.TestName }}</b></td>
                            <td class="text-end py-1">
                              {{ numeralFormat(item.UnitPrice, '0,0[.]00') }}/
                              {{ numeralFormat(item.UnitPrice2, '0,0[.]00') }}/
                              {{ numeralFormat(item.UnitPrice3, '0,0[.]00') }}/
                              {{ numeralFormat(item.UnitPrice4, '0,0[.]00') }}/
                              {{ numeralFormat(item.UnitPrice5, '0,0[.]00') }}
                            </td>
                            <td class="text-start py-1">{{ item.room_name }}</td>
                            <td class="py-1">{{ item.count_items }}</td>
                            <td class="py-1">
                                <button type="button" class="btn btn-primary btn-sm py-0 mx-1" id="Edit"
                                  @click="editBtnClicked(item)"
                                  data-bs-toggle="modal" data-bs-target="#exampleModal">Edit</button>
                                <button class="btn btn-danger btn-sm py-0" id="Delete" @click="cancelRecord(item)">Del</button>
                            </td>
                        </tr>
                      </tbody>
                  </table>
                </div>
                <!-- ปุ่มจัดลำดับก่อนหลัง ในห้องตรวจ -->
                <div class="container my-3" :hidden="rdRoomTypeID == 0 || datalists.length <= 1">
                  <div class="btn-group mb-3" role="group" aria-label="Basic outlined example">
                    <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งขึ้น" @click="upNdown('up');">Up</button>
                    <button type="button" class="btn btn-outline-primary" title="ย้ายตำแหน่งลง" @click="upNdown('down');">Down</button>
                    <button type="button" class="btn btn-outline-primary ms-2" title="จัดเก็บลำดับที่เปลี่ยนแปลง" @click="applySeqItems();">บันทึกลำดับที่จัดเรียง</button>
                  </div>
                  <p class="mb-4" style="font-size:90%">คำแนะนำ : การเรียงลำดับให้แสดงข้อมูลครบทุกแถว โดยการเปลี่ยนจำนวนแถวที่แสดงที่มุมซ้ายด้านบนของตาราง เป็น "Show All entries"</p>
                </div>
              </div>
          </div>
          <div class="col-sm">
              <div class="card mt-2"  style="background-color: GhostWhite;">
                <div class="card-body">
                  <div class="d-grid" v-if="(curRecord.TestID > 0)">
                    <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#addTestModal"
                      :hidden="curRecord.FromItemTest==1"
                      @click="addTestRecord()">เพิ่มเทส</button>
                  </div>
                  <MTestsuitDtl :curRecord="curRecord" :key="countRefreshDtl"
                    @onRefreshDtlAfterUpdate="refreshDtlAfterUpdate"/>
                </div>
              </div>
          </div>
      </div>
      <!-- ปุ่ม Download -->
      <div class="row mt-3">
        <div class="col">
          <vue-excel-xlsx class="btn btn-outline-secondary btn-sm mb-2 float-start" v-if="datalists!==null" title="Download to Excel File"
            :data="datalistsForExcel"
            :columns="columns"
            :filename="'testsuits_list'"
            :sheetname="'ชุดตรวจ'"
            >
            <i class="fa fa-download"></i> Download
          </vue-excel-xlsx>
        </div>
      </div>
    </div>

    <!-- Modal Form -->
    <div id="exampleModal" class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header" style="background-color:Gainsboro">
            <h5 class="modal-title">Test Profiles</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-start">
            <form id="fmTestsuit" @submit.prevent="" >
                <input type="text" hidden class="form-control" id="CorpID" placeholder="" name="CorpID" v-model="globalCorpID" >
                <input type="text" hidden class="form-control" id="action" placeholder="" name="action" v-model="action" >
                <input type="text" hidden class="form-control" id="TestID" placeholder="" name="TestID" v-model="curRecord.TestID" >
                <div class="row mb-2">
                    <div class="col-6">
                        <label for="code" class="mr-sm-2">รหัส/ชื่อ ชุดตรวจ:</label>
                        <input type="text" class="form-control" id="code" placeholder="รหัสชุดตรวจ*" name="TestCode" v-model="curRecord.TestCode" autocomplete="off" required>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <input type="text" class="form-control mb-2" id="TestName"  placeholder="ชื่อชุดตรวจ*" name="TestName" v-model="curRecord.TestName" autocomplete="off" required style="font-weight:bold;">
                        <input type="text" class="form-control mb-2" id="TestName2"  placeholder="ชื่อชุดตรวจ (ไทย)*" name="TestName2" v-model="curRecord.TestName2" autocomplete="off" required>
                    </div>
                </div>
                <div class="row mb-2">
                  <div class="col-10">
                      <div class="input-group input-group-sm">
                        <span class="input-group-text" style="width:120px;">ราคาขาย_1 </span>
                        <input type="number" class="form-control form-control-sm" title="ราคาขาย" name="UnitPrice" v-model="curRecord.UnitPrice" style="background:OldLace;">
                      </div>
                      <div class="input-group input-group-sm">
                        <span class="input-group-text" style="width:120px;">ราคาขาย_2 </span>
                        <input type="number" class="form-control form-control-sm" title="ราคาขาย" name="UnitPrice2" v-model="curRecord.UnitPrice2">
                      </div>
                      <div class="input-group input-group-sm">
                        <span class="input-group-text" style="width:120px;">ราคาขาย_3 </span>
                        <input type="number" class="form-control form-control-sm" title="ราคาขาย" name="UnitPrice3" v-model="curRecord.UnitPrice3">
                      </div>
                      <div class="input-group input-group-sm">
                        <span class="input-group-text" style="width:120px;">ราคาขาย_4 </span>
                        <input type="number" class="form-control form-control-sm" title="ราคาขาย" name="UnitPrice4" v-model="curRecord.UnitPrice4">
                      </div>
                      <div class="input-group input-group-sm mb-2">
                        <span class="input-group-text" style="width:120px;">ราคาขาย_5 </span>
                        <input type="number" class="form-control form-control-sm" title="ราคาขาย" name="UnitPrice5" v-model="curRecord.UnitPrice5">
                      </div>
                  </div>
                </div>

                <div class="row mb-2">
                    <div class="col">
                        <label class="mr-sm-2">สิ่งที่ส่งตรวจ : (คั่นระหว่าง specimen ด้วย ,)</label>
                        <input type="text" class="form-control mb-2" id="Specimen"  placeholder="Specimen" title="ป้อน Specimens"
                          name="Specimen" v-model="curRecord.Specimen" autocomplete="off">
                        <div class="container">
                          <ul class="list-group">
                          <li v-for="item in curRecord.Specimen.split(',')" :key="item" class="list-group-item d-flex justify-content-between align-items-center list-group-item-warning">
                              {{item}}
                              <span class="btn badge bg-danger rounded-pill" @click="removeSpecimen(curRecord.Specimen, item)" title="ลบออก">x</span>
                          </li>
                          </ul>
                        </div>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col">
                        <label for="PriorityIdx">ห้องตรวจ</label>
                        <select id="PriorityIdx" class="form-control" name="PriorityIdx" v-model="curRecord.PriorityIdx">
                            <option v-for="item in roomtypeRows" v-bind:key="item.id" :value="item.id">{{ item.room_name }} | {{item.id}}</option>
                        </select>
                    </div>
                </div>
            </form>
          </div>

          <div class="modal-footer" style="background-color:Gainsboro">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveData()">Save changes</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Form : เลือกเทส เป็นรายการย่อยในชุดตรวจ -->
    <div id="addTestModal" class="modal " tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header" style="background-color:Gainsboro">
            <h5 class="modal-title">เพิ่มเทสให้กับชุดตรวจ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body text-start">
              <table id="myAddTestTable" class="table table-hover table-sm display" style="width: 100%;font-size:80%;">
                <thead class="text-dark" style="background:LightGreen">
                <tr>
                    <th class="text-start" style="width:50px;">รหัสเทส</th>
                    <th class="text-start" style="width:300px;">ชื่อเทส</th>
                    <th class="text-center" style="width:80px;">ห้องตรวจทางคลินิก</th>
                    <th style="width:40px;">คำสั่ง</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="item in itemTestLists" :key="item.ItemTestID" v-bind:data-id="item.ItemTestID">
                        <td class="text-start py-1">{{ item.ItemTestCode }}</td>
                        <td class="text-start py-1"><b>{{ item.ItemTestName }}</b></td>
                        <td class="text-center py-1">{{ item.room_name }}</td>
                        <td class="py-1">
                            <button type="button" class="btn btn-primary btn-sm py-0 mx-1" id="Add" @click="addDtlSuit(item)">Add</button>
                        </td>
                    </tr>
                </tbody>
            </table>
          </div>

          <div class="modal-footer" style="background-color:Gainsboro">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import MTestsuitDtl from './MTestsuitDtl.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Testsuit',
  components: {
    MTestsuitDtl
  },
  data () {
    return {
      columns: [
        { label: 'Code', field: 'TestCode' },
        { label: 'Name', field: 'TestName' },
        { label: 'Name2', field: 'TestName2' },
        { label: 'UnitPrice', field: 'UnitPrice' },
        { label: 'UnitPrice2', field: 'UnitPrice2' },
        { label: 'UnitPrice3', field: 'UnitPrice3' },
        { label: 'UnitPrice4', field: 'UnitPrice4' },
        { label: 'UnitPrice5', field: 'UnitPrice5' },
        { label: 'ItemTestCode', field: 'ItemTestCode' },
        { label: 'ItemTestName', field: 'ItemTestName' },
        { label: 'Seq', field: 'Seq' }
      ],
      index: 0,
      datalists: [],
      TSselectedlist: [], // กรณีเลือก checkbox หลายรายการเทส เพื่อเปลี่ยนห้องตรวจ
      curRecord: {
        Specimen: ''
      },
      action: 'new',
      countRefreshDtl: 0,

      itemTestLists: [] // รายการเทส สำหรับ add เข้าชุดตรวจ
    }
  },
  mounted () {
    // รายการชุดตรวจทั้งหมด
    this.getData()
    // รายการเทสทั้งหมด สำหรับให้เลือกเพื่อเพิ่มในชุดตรวจ
    this.getTestsData()
    // รายการชุดตรวจ+เทส สำหรับ export เป็น excel file
    // this.getTestsuitAndItemsData()
  },
  props: ['roomtypeRows', 'datalistsForExcel', 'rdRoomTypeID'],
  methods: {
    changeRoomtypeForTSSelected (roomtypeRow) {
      // var self = this
      var arrTest = []
      // แปลงข้อมูลจากฟอร์ม
      for (var i = 0; i <= this.TSselectedlist.length - 1; i++) {
        // console.log(table.rows[i].getAttribute('data-id'))
        arrTest.push({
          TestID: this.TSselectedlist[i].TestID,
          roomtypeID: roomtypeRow.id,
          UserID: this.globalUserID
        })
      }
      // console.log(arrTest)

      var self = this
      Swal.fire({
        title: this.TSselectedlist.length + ' รายการ',
        text: 'คุณต้องการย้ายไปห้องตรวจ ' + roomtypeRow.room_name + '..ใช่หรือไม่?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/update_testsuit_changeroom.php',
            data: { request: JSON.stringify(arrTest) }
          }).done(function () {
            Swal.fire({
              text: 'ย้ายห้องตรวจเรียบร้อย',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
            }).then((result) => {
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    // จัดเก็บลำดับที่จัดเรียงใหม่
    applySeqItems () {
      // var self = this
      var arrTS = []
      // แปลงข้อมูลจากฟอร์ม
      var table = document.getElementById('myTSTable')
      for (var i = 1; i < table.rows.length; i++) {
        // console.log(table.rows[i].getAttribute('data-id'))
        arrTS.push({
          PriorityIdx: table.rows[i].getAttribute('data-PriorityIdx'),
          TestID: table.rows[i].getAttribute('data-TestID'),
          Seq: i,
          UserID: this.globalUserID
        })
      }
      // console.log(arrTS)
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/update_testsuit_seqinroom.php',
        data: { request: JSON.stringify(arrTS) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกลำดับใหม่เสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            self.$emit('onDataChangedEvent')
          })
        })
        .fail(function (resp) {
          console.log(resp)
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    upNdown (direction) {
      var rows = document.getElementById('myTSTable').rows
      var parent = rows[this.index].parentNode
      if (direction === 'up') {
        if (this.index > 1) {
          parent.insertBefore(rows[this.index], rows[this.index - 1])
          // when the row go up the index will be equal to index - 1
          this.index = this.index - 1
        }
      }
      if (direction === 'down') {
        if (this.index < rows.length - 1) {
          parent.insertBefore(rows[this.index + 1], rows[this.index])
          // when the row go down the index will be equal to index + 1
          this.index = this.index + 1
        }
      }
    },
    // แสดงแถบสีว่า เลือก row นี้
    getSelectedRow (event, row) {
      // console.log('row Index :')
      // console.log(event.target.parentNode.rowIndex)
      this.index = event.target.parentNode.rowIndex
      var table = document.getElementById('myTSTable')
      for (var i = 1; i < table.rows.length; i++) {
        table.rows[i].style.backgroundColor = 'white'
        table.rows[i].style.color = 'black'
      }
      table.rows[this.index].style.backgroundColor = 'MediumBlue'
      table.rows[this.index].style.color = 'white'
    },

    // ดึงรายการเทสทั้งหมด (ItemTest) สำหรับให้เลือกเพื่อเพิ่มในชุดตรวจ
    getTestsData () {
      MyApiClient.get('getdata/tests_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.itemTestLists = resp.data.response
          this.$nextTick(() => {
            $('#myAddTestTable').DataTable()
          })
          // setTimeout(function () { $('#myTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // หลังจาก เพิ่ม หรือ จัดลำดับ เทสในชุดตรวจ : Refresh Table ด้านขวา
    refreshDtlAfterUpdate () {
      this.tableChanged(this.curRecord)
    },
    removeSpecimen (strSrc, strRem) {
      this.curRecord.Specimen = this.strCommaRemoveValue(strSrc, strRem)
    },
    strCommaRemoveValue (list, value) {
      list = list.split(',')
      list.splice(list.indexOf(value), 1)
      return list.join(',')
    },
    addDtlSuit (item) {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmTestsuit').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      // console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/add_dtl_testsuit.php',
        // url: 'http://localhost/vmedlab/src/service/setdata/add_dtl_testsuit.php',
        data: { id: item.ItemTestID, parentid: this.curRecord.TestID }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1000
          }).then(function (result) {
            // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
            self.countRefreshDtl++
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    },
    toggleTestsuitDtl () {
      this.chkTestsuitDtl = !this.chkTestsuitDtl
    },
    cancelRecord (item) {
      var self = this
      Swal.fire({
        title: item.TestName,
        text: 'คุณแน่ใจหรือไม่...ที่จะลบข้อมูล?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่! แน่ใจ',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'POST',
            url: this.http_baseurl + 'setdata/delete_testsuit.php',
            // url: 'http://localhost/vmedlab/src/service/setdata/cancel_testsuit.php',
            // url: 'http://www.labsmartsoft.com/vmedlab/service/' + 'setdata/cancel_testsuit.php',
            data: { id: item.TestID }
          }).done(function () {
            Swal.fire({
              text: 'ข้อมูลของคุณถูกลบเรียบร้อย',
              icon: 'success',
              confirmButtonText: 'ตกลง'
            }).then((result) => {
            //   self.getData()
              self.$emit('onDataChangedEvent')
            })
          })
        }
      })
    },
    newRecord () {
      this.curRecord = {}
      this.curRecord.Specimen = ''
      this.curRecord.PriorityIdx = this.rdRoomTypeID
      this.action = 'new'
    },
    editBtnClicked (row) {
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
      this.countRefreshDtl++

      // --------------------------------------- //
      this.TSselectedlist = [] // Clear Checkbox แถวที่เลือก
      // ================================ //
      //          การจัดลำดับ
      // แถบสี row ที่คลิก
      // this.getSelectedRow(event, row)
    },
    tableChanged (event, row) {
      if (event.target.parentNode.nodeName !== 'TR') { // ต้องคลิกที่ <TD> เพื่อทำ HighLight แถว
        return
      }
      var curRow = Object.assign({}, row)
      this.curRecord = curRow
      this.action = 'edit'
      // รีเฟรชตารางด้านขวา รายการของชุดตรวจ โดยการเปลี่ยนค่าคีย์ เพื่อ ReRender Component
      this.countRefreshDtl++

      // --------------------------------------- //
      this.TSselectedlist = [] // Clear Checkbox แถวที่เลือก
      // ================================ //
      //          การจัดลำดับ
      // แถบสี row ที่คลิก
      this.getSelectedRow(event, row)
    },
    getData () {
      // MyApiClient.get('getdata/testsuits_all.php?C1=' + this.globalCorpID)
      let phpFile = ''
      if (this.rdRoomTypeID > 0) {
        phpFile = 'getdata/testsuits_where_roomtype.php'
      } else {
        phpFile = 'getdata/testsuits_all.php'
      }
      MyApiClient.get(phpFile + '?C1=' + this.globalCorpID + '&roomtypeID=' + this.rdRoomTypeID)
        .then((resp) => {
          console.log(resp.data.response)
          this.datalists = resp.data.response
          // setTimeout(function () { $('#myTSTable').DataTable() }, 0)
          setTimeout(function () {
            $('#myTSTable').DataTable(
              { lengthMenu: [[10, 25, 50, -1], [10, 25, 50, 'All']] },
              { order: [[0, 'asc'], [1, 'asc']] }
            )
          }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    saveData () {
      var self = this
      // แปลงข้อมูลจากฟอร์ม
      var x = $('#fmTestsuit').serializeArray()
      var formData = {}
      $.each(x, function (i, field) {
        $.extend(formData, { [field.name]: field.value })
      })
      console.log(formData)
      // Insert/Update by call API
      $.ajax({
        type: 'POST',
        url: this.http_baseurl + 'setdata/insert_testsuit.php',
        // url: 'http://localhost/vmedlab/src/service/setdata/insert_testsuit.php',
        data: { request: JSON.stringify(formData) }
      })
        .done(function (resp) {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'บันทึกข้อมูลเสร็จเรียบร้อย',
            showConfirmButton: false,
            timer: 1500
          }).then(function (result) {
            // self.getData()
            self.$emit('onDataChangedEvent')
          })
        })
        .fail(function (resp) {
          // alert('Not Saved')
          Swal.fire({ icon: 'error', text: 'ไม่สามารถบันทึกข้อมูลได้' })
        })
    }
  }
}

</script>

<style>

</style>
